module.exports = __webpack_public_path__ + "static/forsecure-5a8e168620bf92b9d6d3d7a95c96fbb7.png";